'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  END_WORD: '$',
  END_WORD_REPLACER: '9a219a89-91cd-42e2-abd5-eb113af08ca8',
  PERMS_MIN_LEN: 2
};
module.exports = exports['default'];